export enum EventEntryStateDescriptionEnum {
  BRAK = 'event.details.entryState.empty',
  DRZWI_OTWARTE = 'event.details.entryState.open',
  DRZWI_NIEOTWARTE = 'event.details.entryState.closed',
}
